import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Stack, shape, Text, Link, Button } from '@hub-la/design-system';
import CallMadeIcon from '@mui/icons-material/CallMade';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import '../../../domain/dtos/alert-type.js';
import '../../../domain/dtos/error-type.js';
import '../../../domain/dtos/main-content-type.js';
import { PostEventType } from '../../../domain/dtos/post-event-type.js';
import '../../../domain/dtos/post-status.js';
import '../../../domain/dtos/query-key.js';
import '../../../domain/dtos/remove-dialog-action.js';
import img$6 from '../../assets/discord-live.js';
import img$7 from '../../assets/discord.js';
import img$4 from '../../assets/meets-live.js';
import img$5 from '../../assets/meets.js';
import img$2 from '../../assets/youtube-live.js';
import img$3 from '../../assets/youtube.js';
import img from '../../assets/zoom-live.js';
import img$1 from '../../assets/zoom.js';
import { getSiteUrl } from '../../utils/routes.js';
import { Wrapper, EventLiveContainer } from './event-card.styled.js';

const EventCard = ({
  type,
  startTime,
  endTime,
  liveId,
  started: _started = false,
  onComplete
}) => {
  const {
    t
  } = useTranslation();
  if (endTime < new Date()) {
    return jsx(Fragment, {});
  }
  const getIcon = () => {
    switch (type) {
      case PostEventType.discord:
        return _started ? img$6 : img$7;
      case PostEventType.meets:
        return _started ? img$4 : img$5;
      case PostEventType.youtube:
        return _started ? img$2 : img$3;
      case PostEventType.zoom:
        return _started ? img : img$1;
      default:
        return _started ? img : img$1;
    }
  };
  return jsxs(Wrapper, Object.assign({
    started: _started,
    direction: ['column', 'row'],
    "data-testid": "event-card"
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      spacing: 4,
      alignItems: "center",
      flex: 1
    }, {
      children: [jsx(EventLiveContainer, Object.assign({
        started: _started,
        borderRadius: shape('small'),
        overflow: "hidden"
      }, {
        children: jsx("img", {
          src: getIcon(),
          alt: "Meeting Logo",
          width: 56,
          height: 56
        })
      })), jsxs(Stack, Object.assign({
        direction: "column"
      }, {
        children: [jsx(Text, {
          children: jsx("b", {
            children: t(`postDetail.meeting.type.${type}`)
          })
        }), _started ? jsx(Text, Object.assign({
          color: "outline"
        }, {
          children: getSiteUrl('/live/' + liveId).replace('https://', '').replace('http://', '')
        })) : jsxs(Text, Object.assign({
          color: "outline"
        }, {
          children: ["Faltam", ' ', jsx(Countdown, {
            date: startTime,
            renderer: ({
              days,
              hours,
              minutes,
              seconds
            }) => jsxs(Fragment, {
              children: [days, "d ", hours, "h ", minutes, "min ", seconds, "s"]
            }),
            onComplete: () => onComplete === null || onComplete === void 0 ? void 0 : onComplete()
          })]
        }))]
      }))]
    })), _started && jsx(EventLiveContainer, Object.assign({
      started: _started,
      borderRadius: shape('small'),
      alignSelf: "center",
      marginTop: [4, 0],
      width: ['100%', 379]
    }, {
      children: jsx(Link, Object.assign({
        href: '/live/' + liveId,
        "data-testid": "join-live-button"
      }, {
        children: jsx(Button, Object.assign({
          fullWidth: true,
          startIcon: jsx(CallMadeIcon, {}),
          style: {
            backgroundColor: 'transparent'
          }
        }, {
          children: t('postDetail.meeting.join')
        }))
      }))
    }))]
  }));
};

export { EventCard };
